// extracted by mini-css-extract-plugin
export var details = "_kv-0";
export var inspectorPopover = "_kv-1";